<div *ngIf="sortOptions as options" class="select-container font-body-1 regular-type flex flex--center underline">
  <select
    class="nordic-blue-900-text medium-type focus-inset"
    [name]="fieldName"
    (ngModelChange)="optionChange.emit($event)"
    [ngModel]="selected$ | async"
  >
    <option *ngFor="let option of options" [attr.data-option-value]="option.value" [ngValue]="option.value">
      {{ option.label }}
    </option>
  </select>
</div>
